import { render } from "./ProfileManagementForm.vue?vue&type=template&id=3a2cdd50&scoped=true"
import script from "./ProfileManagementForm.vue?vue&type=script&lang=js"
export * from "./ProfileManagementForm.vue?vue&type=script&lang=js"

import "./ProfileManagementForm.vue?vue&type=style&index=0&id=3a2cdd50&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2cdd50"]])

export default __exports__